import { GridInputValue } from '../../../../types/types';

export const parseDateTimeValue = (value: GridInputValue) =>
  typeof value === 'string' ? value : null;
